var _rect, _rect2, _g, _circle, _path, _path2, _path3, _circle2, _path4, _path5, _path6, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingpagebg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 290,
    viewBox: "0 0 1440 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 290,
    fill: "#5070DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_299_22263",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 290
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 290,
    fill: "#5070DE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_299_22263)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1056.28 0L733.805 459.77L1157.81 0L1056.28 0Z",
    fill: "url(#paint0_radial_299_22263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 0L1393.87 0L733.805 459.77L1440 89.7421V0Z",
    fill: "url(#paint1_radial_299_22263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440 174.312L733.805 459.769L1440 270.287V174.312Z",
    fill: "url(#paint2_radial_299_22263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.413 0L733.805 459.77L1008.11 0L928.413 0Z",
    fill: "url(#paint3_radial_299_22263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.68 0L733.805 459.77L1304.78 0L1204.68 0Z",
    fill: "url(#paint4_radial_299_22263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.856 0L733.807 459.77L720.762 0L653.856 0Z",
    fill: "url(#paint5_radial_299_22263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 26.2458L733.805 459.77L106.266 0H0V26.2458Z",
    fill: "url(#paint6_radial_299_22263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.6 0L733.804 459.77L447.797 0L353.6 0Z",
    fill: "url(#paint7_radial_299_22263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.725 0L733.805 459.77L880.419 0L788.725 0Z",
    fill: "url(#paint8_radial_299_22263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 275.817V367.479L733.805 459.771L0 275.817Z",
    fill: "url(#paint9_radial_299_22263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.164 0L733.804 459.77L587.348 0L513.164 0Z",
    fill: "url(#paint10_radial_299_22263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 90.9987L0 198.145L733.805 459.77L0 90.9987Z",
    fill: "url(#paint11_radial_299_22263)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.831 0L733.804 459.77L294.274 0L162.831 0Z",
    fill: "url(#paint12_radial_299_22263)"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 280.801,
    cy: 145.795,
    r: 4.46066,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219.723 182.168C219.723 182.168 217.887 189.579 209.191 189.898C203.394 190.111 202.031 184.103 195.259 188.17C192.243 189.981 190 195.484 190 195.484",
    stroke: "#FF7E00",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M276.897 210.474L280.118 218.963L288.607 222.184L280.118 225.404L276.897 233.893L273.677 225.404L265.188 222.184L273.677 218.963L276.897 210.474Z",
    fill: "#FEB926"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M357.592 111.196C358.688 120.726 380.835 130.225 381.328 122.428C382.11 110.072 352.242 119.705 392.991 135.896",
    stroke: "#FEB926",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1269.92,
    cy: 195.921,
    r: 8.92133,
    fill: "#FEB926"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.92 125L1070.24 131.6L1076.84 133.921L1070.24 136.243L1067.92 142.843L1065.6 136.243L1059 133.921L1065.6 131.6L1067.92 125Z",
    fill: "#FF7E00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1146 243.479C1151.54 242.693 1163.61 244.017 1167.6 255.596",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.09 154.137C1163.09 154.137 1171.18 158.255 1174.57 154.564C1177.67 151.198 1174.09 145.944 1177.84 143.318C1180.88 141.182 1187.34 142.589 1187.34 142.589",
    stroke: "#FEB926",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1193,
    y: 207,
    width: 7.80616,
    height: 7.80616,
    rx: 2,
    fill: "#FEB926"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_299_22263",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(725.596 461.473) rotate(-169.384) scale(622.116 574.593)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_299_22263",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(725.596 461.473) rotate(-169.384) scale(622.124 574.601)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_299_22263",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(741.477 456.594) scale(624.074 572.762)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_299_22263",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(741.477 456.595) scale(624.075 572.763)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_299_22263",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(741.477 456.595) scale(624.075 572.763)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_299_22263",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(726.609 461.701) rotate(-169.384) scale(617.145 570.002)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_299_22263",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(725.609 461.413) rotate(-169.384) scale(620.015 572.653)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_299_22263",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(725.594 461.473) rotate(-169.384) scale(622.105 574.583)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_299_22263",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(720.935 460.611) rotate(-169.384) scale(625.037 577.29)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_299_22263",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(725.59 461.5) rotate(-169.384) scale(622.106 574.584)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_299_22263",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(741.476 456.595) scale(624.077 572.765)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_299_22263",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(741.477 456.595) scale(624.078 572.766)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_299_22263",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(741.476 456.595) scale(624.06 572.749)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingpagebg);
export default __webpack_public_path__ + "static/media/Landingpagebg.3c1ee712f5c1446f54b93794e4c9cd33.svg";
export { ForwardRef as ReactComponent };